<template>
    <div class="" id="map">
        <agent-map v-bind:isOfficePage="true"></agent-map>
    </div>
</template>

<script>
    import SmoothScroll from 'smooth-scroll';
    import he from 'he';
	import { mapState, mapActions, mapMutations } from 'vuex';
    import AgentMap from '../components/map';

	export default {
		props: ['location'],
		data: function () {
			return {
			}
		},
		computed: mapState({
            listing: state => state.listing.listing,
            selectedLocation: state => state.listing.selectedLocation
		}),
		components: {
            'agent-map': AgentMap
		},
		mounted: function () {
            let _this = this;
            this.setListing(this.location);
		},
		methods: {
            ...mapMutations('listing', { setListing: 'setListing' }),
        },
    }
</script>